<template>
  <div class="home" ref="home">
    <slide :data="imagelist" class="slide"></slide>
    <div class="two">
      <badges ref="badges"></badges>
      <slogan></slogan>
    </div>
    <galery ref="galery"></galery>
    <contact ref="contact"></contact>
    <project-modal v-if="showModal"></project-modal>
    <img id="up" src="@/assets/img/up-arrow.png" @click="scrollToNav"/>
  </div>
</template>

<script>
// @ is an alias to /src
import Badges from '@/components/Badges.vue';
import Galery from '@/components/Galery.vue';
import Contact from '@/components/Contact.vue';
import ProjectModal from '@/components/ProjectModal.vue';
import Slide from '@/components/Slide.vue';
import Slogan from '@/components/Slogan.vue';
import Event from '@/event.js';
import Navigation from '@/navigation.js'

export default {
  name: 'home',
  components: {
    Badges,
    Galery,
    Contact,
    ProjectModal,
    Slide,
    Slogan
  },
  data () {
    return {
      showModal: false,
      imagelist: ['temp1.jpg', 'temp2.jpg']
    }
  },
  methods: {
    scrollToBadges() {
      this.$refs.badges.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
    scrollToGalery () {
      this.$refs.galery.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
    scrollToContact () {
      this.$refs.contact.$el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
    scrollToNav() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  },
  mounted () {
    Event.$on('close', () => {
      this.showModal = false;
    });
    Event.$on('open', () => {
      this.showModal = true;
    });
    Navigation.$on('contact', () => {
      this.scrollToContact();
    });
    Navigation.$on('badges', () => {
      this.scrollToBadges();
    });
    Navigation.$on('galery', () => {
      this.scrollToGalery();
    });
  }
};
</script>
<style lang="scss" scoped>
  .slide {
    width: 100%;
    height: 800px;
  }

  .two {
    display: flex;
    flex-direction: row;
    width: 100%;
  }

  #up {
    position: fixed;
    bottom: 30px;
    right: 30px;
    width: 40px;
    cursor: pointer;
  }

  @media screen and (max-width: 1024px) {
    .two {
      display: block;
    }
  }
</style>

